// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"_025a50318d--dropdown--3jusx","list":"_025a50318d--list--3-40V","dropdown_item":"_025a50318d--dropdown_item--3ip-K"};